module.exports = __webpack_public_path__ + "img/gallery-img-3s.2fc608ec.jpg";